import * as React from 'react';

import type { NavigationScreenOrgInvite } from '@gitbook/app-navigation';
import { Dialog, LoadingPanel } from '@gitbook/spine-react';

import { NavigationRedirect } from '../../navigation';

const InvitesDialogContent = React.lazy(() =>
    import('./InvitesDialogContent').then((m) => ({
        default: m.InvitesDialogContent,
    }))
);

/**
 * Dialog to invite members to an organization.
 * */
export function InvitesOrganizationScreen(props: {
    screen: NavigationScreenOrgInvite;
    isOverlay: boolean;
}): React.ReactElement {
    const { screen, isOverlay } = props;

    // This dialog should always be rendered as an overlay
    if (!isOverlay) {
        return (
            <NavigationRedirect
                to={{
                    screen: {
                        type: 'org_settings',
                        organization: screen.organization,
                        tab: { type: 'members' },
                    },
                    overlay: {
                        type: 'org_invite',
                        organization: screen.organization,
                    },
                }}
                replace
            />
        );
    }

    return (
        <Dialog>
            <React.Suspense fallback={<LoadingPanel />}>
                <InvitesDialogContent organizationId={screen.organization} />
            </React.Suspense>
        </Dialog>
    );
}
